interface LogoProps {
  className?: string;
  src?: string;
}

export default function Logo({
  className = "",
  src = "/images/namba/logo-default.png",
}: LogoProps) {
  return (
    <img
      src={src}
      alt="namba"
      title="ナンバ ロゴ"
      className={`block w-auto select-none align-middle ${className}`}
    />
  );
}